import * as React from 'react';
import { CustomerDetailsForm } from '../components/customer-details-form';
import { useLocalize } from '../components/localize-context';
import { Seo } from '../components/seo';

/**
 *
 * @param {import('gatsby').PageRendererProps} props
 */
export default function McoRegistration(props) {
  const l = useLocalize();

  const params = React.useMemo(() => {
    try {
      const params = new URLSearchParams(props.location.search);
      return {
        adult: Number(params.get('adult') || 0) || undefined,
        kid: Number(params.get('kid') || 0) || undefined,
      };
    } catch (e) {
      return {};
    }
  }, [props.location]);

  return (
    <>
      <Seo title={l('MCO Registration')} />
      <div className="container py-6 px-4 max-w-4xl mx-auto">
        <h1 className="text-3xl mb-4">{l('MCO Registration')}</h1>
        <CustomerDetailsForm
          initialNumOfAdult={params.adult}
          initialNumOfKid={params.kid}
        />
      </div>
    </>
  );
}
